// extracted by mini-css-extract-plugin
module.exports = {"service":"Service_service__3iLwt","price":"Service_price__1mR0J","load":"Service_load__2BBpH"};